import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { staticResources } from '~/i18n/resources'

i18n
  .use(initReactI18next)
  .init({
    lng: 'ja',
    fallbackLng: 'ja',
    defaultNS: 'common',
    returnEmptyString: false,
    // 動的翻訳 namespace では原文テキストをキーとして使うため区切り文字を無効化する。
    // 'static' namespace のキーはドットを含むが、keySeparator:false なら文字列として扱われる
    // ('schedule.dueToday' 全体が 1 キー）。
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      // React は JSX 内の値を textContent でセットするため HTML として解釈されず、
      // XSS 対策のエスケープは React 側で実質担保される。
      // i18next のエスケープを有効にすると二重エスケープになるため false にしている。
      // ref:
      // - https://react.i18next.com/latest/i18next-instance
      // - https://github.com/i18next/react-i18next/issues/277
      escapeValue: false,
    },
    // 固定UI文言（翻訳APIを通さない）を静的 resource として事前登録する。
    // 動的翻訳側は useQueryTranslation で 'translation' namespace に追加される。
    resources: staticResources,
    react: {
      useSuspense: false,
    },
    // キーが見つからない場合、defaultValue があればそれを、なければキー名を返す
    parseMissingKeyHandler: (key, defaultValue) => defaultValue ?? key,
  })
  .catch(() => {
    // i18next の初期化失敗時はフォールバック（原文表示）で動作するため、ここでは何もしない
  })

export { i18n }
